<template>
    <div class="filter-selected" v-if="filterKeys.length">
        <template v-for="key in filterKeys">
            <template v-if="selectedFilters[key]">
                <template v-for="value in selectedFilters[key]" v-if="getFilter(key)">
                    <template v-if="getFilter(key).type === constants.filterType.colors">
                        <sal-filter-swatch-element :status="constants.swatchStatus.remove" :name="key" :swatches="getOption(getFilter(key), value)" />
                    </template>
                    <template v-else>
                        <div class="remove-filter" :class="themeClass(key)" @click="remove(key, value)">
                            <span v-html="displayValue(key, value)"></span>
                            <span class="icon-remove" />
                        </div>
                    </template>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import {constants} from "@productfinder/shared/constants";
import SalFilterSwatchElement from "@productfinder/components/sal-filter-swatch/sal-filter-swatch-element";

export default {
        name: "sal-filter-selected",
        components: {SalFilterSwatchElement},
        data() {
            return {

            }
        },
        computed: {
            constants() {
                return constants
            },
            filterKeys() {
                return Object.keys(this.selectedFilters)
            },
            selectedFilters() {
                return this.$store.getters.selectedFilters
            }
        },
        methods: {
            themeClass(key) {
                if ((/*key === 'sustain' || */key.startsWith('greentool_'))) {
                    return 'remove-filter--sustainable';
                }
                return 'remove-filter--secondary';
            },
            remove(name, value) {
                this.$store.dispatch('removeFilterState', { filterName: name, value: value });
            },
            getFilter(name) {
            	return this.$store.getters.filterByName(name);
            },
            getOption(filter, value) {
                return filter.options.find(option => {
                    return option.value === value
                });
            },
            displayValue(key, value) {
                const filter = this.getFilter(key);
                if (filter) {
                    // Checkbox
                    if (filter.type === constants.filterType.checkbox) {
                        return filter.title;
                    }
                    // Buttons
                    else if (filter.type === constants.filterType.button || filter.type === constants.filterType.checkboxes) {
                        const option = this.getOption(filter, value);
                        if (option && option.title) {
                            return option.title;
                        }
                    }
                    // Dropdowns
                    else if (filter.type === constants.filterType.select) {
                        const option = this.getOption(filter, value);
                        if (option && option.title) {
                            if (option.title.startsWith('!') || option.title.startsWith('-')) {
                                return option.title.substring(1);
                            }
                            return option.title;
                        }
                        return value;
                    }
                    // Selection Groups
                    else if (filter.type === constants.filterType.selectiongroup) {
                        const option = this.getOption(filter, value);
                        let retVal = value;
                        if (option && option.title) {
                            retVal = option.title;
                        }
                        return filter.title + " " + retVal;
                    }
                }

                return value;
            }
        },
    }
</script>
